module.exports = __webpack_public_path__ + "static/media/mission.f7e6f49d.jpeg";